module.exports = __webpack_public_path__ + "img/f280-cooling.949e3226.jpg";